import React, { useState } from 'react';
import { AccordionFieldsFragment } from '@src/generated/graphql';

type AccordionFaqComponentProps = {
  content: AccordionFieldsFragment;
};

const AccordionFaqComponent = ({ content }: AccordionFaqComponentProps) => {
  const { title, accordionItemsCollection } = content;
  const items = accordionItemsCollection?.items || [];
  const [openIndexes, setOpenIndexes] = useState<Set<number>>(new Set()); // Empty Set means all closed initially

  const toggleAccordion = (index: number) => {
    const newOpenIndexes = new Set(openIndexes);
    if (newOpenIndexes.has(index)) {
      newOpenIndexes.delete(index);
    } else {
      newOpenIndexes.add(index);
    }
    setOpenIndexes(newOpenIndexes);
  };

  return (
    <div className="faq-section">
      <div className="container-fluid custom-spacer-col faq-space">
        <div className="faq-inner">
          <div className="faq-heading">
            <h2>{title}</h2>
          </div>

          <div className="faq-accordian accordion">
            {items.map((item, index) => (
              <div key={item?.sys?.id || index} className="faq-box accordion-item">
                <div
                  className={`faq-header accordion-btn ${openIndexes.has(index) ? 'active' : ''}`}
                  id={`accordion-button-${index + 1}`}
                  aria-expanded={openIndexes.has(index)}
                  onClick={() => toggleAccordion(index)}
                  role="button"
                  tabIndex={0}
                >
                  <div className="faq-count">
                    <span>{(index + 1).toString().padStart(2, '0')}</span>
                  </div>
                  <div className="header-text">
                    <h4>{item?.itemText}</h4>

                    <svg
                      width="19"
                      height="22"
                      viewBox="0 0 19 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transform: openIndexes.has(index) ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      <path
                        d="M19.0001 9.64286L17.4441 11.2143L10.9538 4.7449L10.9538 21.5H8.70161L8.70161 4.7449L2.23178 11.2143L0.655273 9.64286L9.82769 0.5L19.0001 9.64286Z"
                        fill="#F32F52"
                      />
                    </svg>
                  </div>
                </div>

                <div 
                  className={`faq-ans accordion-content ${openIndexes.has(index) ? 'active' : ''}`}
                  style={{ display: openIndexes.has(index) ? 'block' : 'none' }}
                >
                  <p>
                    {item?.itemDescriptionJson?.json.content[0].content[0].value}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionFaqComponent;